<template>
  <div class="row text-left border-bottom mt-4 mb-4 ml-md-2 ml-md-2">
    <div class="col-5 col-md-3 text-center">
      <div v-if="review.booking_ok">
        <img
          src="../../assets/img/icons/emoji_happy.png"
          width="40px"
        >
        <h6 class="mt-2">
          ¡{{ $t('lang.reviews.all_ok') }}!
        </h6>
      </div>

      <div v-else>
        <img
          src="../../assets/img/icons/emoji_neutral.png"
          width="40px"
        >
        <h6 class="mt-2">
          {{ $t('lang.reviews.any_problem') }}
        </h6>
      </div>
    </div>

    <div class="col rating reviews-container">
      <h6> {{ review.booking.user.name }} </h6>
      <p class="mb-2">
        <span class="rev-info">
          {{ review_date }}
        </span>
      </p>
      <p
        class="mb-4"
        style="color: #777;"
      >
        {{ review.comment }}
      </p>
    </div>
  </div>
</template>

<script>
import TimeAgo from 'javascript-time-ago';

import en from 'javascript-time-ago/locale/en';

import es from 'javascript-time-ago/locale/es';

import store from '../../stores/store';

TimeAgo.addLocale(en);
TimeAgo.addLocale(es);

export default {
  name: 'StoreReview',

  props: {
    review: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {};
  },

  computed: {
    review_date() {
      const language = store.state.main.lang;
      const timeAgo = new TimeAgo(language);

      const reviewDate = new Date((`${this.review.updated_at}`).replace(/-/g, '/')); // Replace function needed to work on Safari
      return (timeAgo.format(reviewDate));
    },
  },
};
</script>

<style scoped>

</style>
